export default "__VITE_ASSET__B6UWQR_q__"